import axios from 'axios';
import { Recordatorio } from '../../domain/entities/Recordatorio';
import { CryptoInterceptor } from '../../infrastructure/api/CryptoInterceptor';

export class RecordatorioFormService {
  private baseUrl: string;
  private axiosInstance;
  private cryptoInterceptor: CryptoInterceptor;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || '';
    this.axiosInstance = axios.create({
      baseURL: this.baseUrl,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Gravitee-Api-Key': process.env.REACT_APP_GRAVITEE_API_KEY
      }
    });

    this.cryptoInterceptor = new CryptoInterceptor();
    this.axiosInstance.interceptors.request.use(
      this.cryptoInterceptor.requestInterceptor,
      error => Promise.reject(error)
    );
    this.axiosInstance.interceptors.response.use(
      this.cryptoInterceptor.responseInterceptor,
      this.cryptoInterceptor.errorInterceptor
    );
  }

  async getFormToken(recordatorio: Recordatorio, paymentAmount: number): Promise<string> {
    try {
      const payload = {
        nroRecordatorio: recordatorio.nroRecordatorio,
        total: paymentAmount,
        clientId: recordatorio.nitCliente,
        clientName: recordatorio.nombreCliente
      };

      const response = await this.axiosInstance.post('SolicitarTokenRecordatorio', payload);

      const extractFormToken = (data: any): string | null => {
        if (!data) return null;
        if (data.data?.formToken) return data.data.formToken;
        const jsonStr = JSON.stringify(data);
        const tokenMatch = jsonStr.match(/formToken":\s*"([\w\d]{20,})"/);
        if (tokenMatch && tokenMatch[1]) return tokenMatch[1];
        if (typeof data === 'object') {
          if (data.answer?.formToken && typeof data.answer.formToken === 'string') {
            if (/^[\w\d]{20,}$/.test(data.answer.formToken)) return data.answer.formToken;
          }
          for (const key in data) {
            if (key === 'formToken' && typeof data[key] === 'string' && /^[\w\d]{20,}$/.test(data[key])) {
              return data[key];
            }
            const value = data[key];
            if (typeof value === 'object' && value !== null) {
              const result = extractFormToken(value);
              if (result) return result;
            }
          }
        }
        return null;
      };

      const token = extractFormToken(response.data);
      if (token) return token;

      throw new Error('Formato de respuesta inesperado: no se pudo encontrar el token');
    } catch (error) {
      console.error('Error al obtener token de recordatorio:', error);
      throw new Error('No se pudo obtener el token del formulario de pago');
    }
  }
}
